import type { LinkItem } from '../../doc/schema';
import { useAssetUrl } from '../assets/localAssets';
import { pickVariant } from '../assets/variants';
import { usePane } from '../context';

function hostOf(url: string): string {
  try {
    return new URL(url).host.replace(/^www\./, '');
  } catch {
    return url;
  }
}

/** Website card: preview image, title, description, host. Double-click opens the link. */
export function LinkBody({ item }: { item: LinkItem }) {
  const { url, title, description, image, imageAssetId, site, status } = item.props;
  return (
    <div className={`link-card link-${status}`}>
      {imageAssetId ? (
        <KeptImage assetId={imageAssetId} size={Math.max(item.w, item.h)} />
      ) : image ? (
        <div className="link-image" style={{ backgroundImage: `url("${image.replace(/"/g, '%22')}")` }} />
      ) : (
        <div className="link-image link-image-empty">{status === 'loading' ? '…' : hostOf(url).slice(0, 1).toUpperCase()}</div>
      )}
      <div className="link-body">
        <div className="link-title">{title || url}</div>
        {description && <div className="link-desc">{description}</div>}
        <div className="link-site">
          {site || hostOf(url)}
          {status === 'loading' && ' · loading preview'}
          {status === 'error' && ' · no preview'}
        </div>
      </div>
    </div>
  );
}

/**
 * A preview picture kept on the board, in the variant that suits the on-screen size. Marked as
 * the cover so the PNG export can draw it (pictures do not survive the DOM snapshot).
 */
function KeptImage({ assetId, size }: { assetId: string; size: number }) {
  const zoom = usePane((s) => s.settledZoom);
  const dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
  const url = useAssetUrl(assetId, pickVariant(size * zoom * dpr));
  return <div className="link-image" data-cover style={url ? { backgroundImage: `url("${url}")` } : undefined} />;
}
